import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { each as _each, get as _get } from 'lodash';

// constant
import { ClaimDetailConstant } from '../../models/claim-detail-constants';
// models
import { ClaimDetailMonetaryTransactionsModel } from '../../models/claim-detail.model';
import { ClaimPaymentsDataModel } from '../../models/claim-payments-data.model';

@Component({
  selector: 'ds-claim-status-payments',
  templateUrl: './claim-status-payments.component.html',
  styleUrls: ['../../containers/auto-claim-status/auto-claim-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimStatusPaymentsComponent implements OnInit {
  @Input() claimPaymentsData: ClaimPaymentsDataModel;
  public firstPartyPaymentTransactions = new Array<ClaimDetailMonetaryTransactionsModel>();
  public thirdPartyIndicator = false;
  public noPaymentsMade = false;

  constructor() {}

  ngOnInit() {
    this.getPaymentTransactions(this.claimPaymentsData.monetaryTransactions);
  }

  private getPaymentTransactions(transactions: Array<ClaimDetailMonetaryTransactionsModel>) {
    const submittedPaymentTransactions = [];
    if (transactions.length > 0) {
      _each(transactions, transaction => {
        if (
          _get(transaction, 'typeOfTransactionStatusCode', '').toString().toUpperCase() ===
          'SUBMITTED'
        ) {
          submittedPaymentTransactions.push(transaction);
        }
      });
      if (submittedPaymentTransactions.length > 0) {
        _each(submittedPaymentTransactions, transaction => {
          if (
            _get(transaction, 'typeOfPaymentPaidToCode', '').toString().toUpperCase() ===
            ClaimDetailConstant.FIRST_PARTY
          ) {
            this.firstPartyPaymentTransactions.push(transaction);
          } else if (
            _get(transaction, 'typeOfPaymentPaidToCode', '').toString().toUpperCase() ===
            ClaimDetailConstant.THIRD_PARTY
          ) {
            this.thirdPartyIndicator = true;
          }
        });
      } else {
        this.noPaymentsMade = true;
      }
    } else {
      this.noPaymentsMade = true;
    }
  }
}
